import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import { Buttons, formConfig } from "./AutorizacionComisiones.form";
import { AutorizacionComisionesTable } from "./AutorizacionComisiones.table";
import {
  AutorizacionComisionMockUp,
  ResumenAutorizacionMockUp
} from "./AutorizacionComisiones.types";
import { mockData, mockResumen } from "./AutorizacionComisiones.data";
import Layout from "../../layout";
import { Helmet } from "react-helmet";
import { successNotification } from "../../../../utils/notifications";

interface State {
  tipoBusqueda: string;
  data: AutorizacionComisionMockUp[];
  resumen: ResumenAutorizacionMockUp | null;
  selectedItems: AutorizacionComisionMockUp[];
}

export default class AutorizacionComisionesComponent extends Component<
  {},
  State
> {
  state: State = {
    tipoBusqueda: "",
    data: [],
    resumen: null,
    selectedItems: []
  };

  handleSubmit = (values: any) => {
    this.setState({
      tipoBusqueda: values.tipoBusqueda,
      data: mockData,
      resumen: mockResumen
    });

    successNotification("Cargado correctamente");
  };

  handleSelectionChange = (selected: AutorizacionComisionMockUp[]) => {
    this.setState({ selectedItems: selected });
  };

  handleExport = () => {
    successNotification("Exportado correctamente");
  };

  onChange = (_values: any) => {
    // Placeholder para onChange
  };

  render() {
    const { resumen, data } = this.state;

    return (
      <main>
        <Layout>
          <Helmet title="Mockup" />
          <Container>
            <FormBuilder
              config={formConfig}
              submit={this.handleSubmit}
              onChange={this.onChange}
            ></FormBuilder>

            {resumen && (
              <Row className="mb-4">
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.ventas}</h3>
                      <p>Ventas</p>
                      <small className="text-muted">
                        {resumen.ventasRechazadas} rechazadas
                      </small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.anualidades}</h3>
                      <p>Reactivaciones</p>
                      <small className="text-muted">
                        {resumen.anualidadesRechazadas} rechazadas
                      </small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{64}</h3>
                      <p>Integrantes</p>
                      <small className="text-muted">{18} con Cargo</small>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>${resumen.montoTotal.toFixed(2)}</h3>
                      <p>Monto Total</p>
                      <small
                        className={
                          resumen.autorizado ? "text-success" : "text-danger"
                        }
                      >
                        {resumen.autorizado ? "Autorizado" : "No autorizado"}
                      </small>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

            {data.length > 0 && (
              <AutorizacionComisionesTable
                data={data}
                onSelectionChange={this.handleSelectionChange}
                onExport={this.handleExport}
              />
            )}
          </Container>
        </Layout>
      </main>
    );
  }
}
